import React from 'react';

const SkeletonBody = () => {
  return (
    <div className="space-y-3">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="h-5 w-full animate-pulse rounded bg-slate-200" />
      ))}
    </div>
  );
};

export default React.memo(SkeletonBody);
